/**
 * Social Share – standalone Alpine.js component
 *
 * For use when Alpine is loaded globally (e.g. via CDN or a bundled script tag)
 * rather than through an ES-module pipeline.
 *
 * Usage:
 *   1. Load Alpine.js *before* this script, or load this script with defer and
 *      Alpine with defer — order matters.
 *
 *      <script defer src="path/to/alpine.min.js"></script>
 *      <script defer src="path/to/social-share.standalone.js"></script>
 *
 *   2. If you use Alpine's default `x-` prefix, replace every `data-x-` attribute
 *      in Default.cshtml with `x-` (e.g. `x-data`, `x-on:click`, `x-show`, etc.)
 *      and remove the Alpine.prefix() call below.
 *
 *   3. Add the wrapper element to your HTML:
 *      <div data-x-data="socialShare"> ... </div>
 */
document.addEventListener('alpine:init', () => {

    // Remove this line if your project uses the default `x-` prefix instead of `data-x-`.
    // Alpine.prefix('data-x-');

    Alpine.data('socialShare', () => ({
        open: false,
        copyLabel: 'Copy Link',
        _previousFocus: null,
        _copyTimeout: null,

        init() {
            this._onKeydown = (e) => {
                if (e.key === 'Escape' && this.open) this.hide();
            };
            document.addEventListener('keydown', this._onKeydown);
        },

        destroy() {
            document.removeEventListener('keydown', this._onKeydown);
            if (this._copyTimeout) clearTimeout(this._copyTimeout);
        },

        show() {
            this._previousFocus = document.activeElement;
            this.open = true;

            this.$nextTick(() => {
                const closeBtn = this.$el.querySelector('.social-share__close');
                if (closeBtn) closeBtn.focus();
            });
        },

        hide() {
            this.open = false;
            this.$nextTick(() => {
                if (this._previousFocus) this._previousFocus.focus();
            });
        },

        toggle() {
            this.open ? this.hide() : this.show();
        },

        async copyLink(url) {
            if (!url) return;

            try {
                await navigator.clipboard.writeText(url);
                this.copyLabel = 'Copied!';
            } catch {
                // Fallback for older browsers
                const ta = document.createElement('textarea');
                ta.value = url;
                ta.style.position = 'fixed';
                ta.style.opacity = '0';
                document.body.appendChild(ta);
                ta.focus();
                ta.select();
                try {
                    document.execCommand('copy');
                    this.copyLabel = 'Copied!';
                } catch {
                    this.copyLabel = 'Copy failed';
                }
                document.body.removeChild(ta);
            }

            if (this._copyTimeout) clearTimeout(this._copyTimeout);
            this._copyTimeout = setTimeout(() => {
                this.copyLabel = 'Copy Link';
            }, 2500);
        }
    }));

});
